/** 支付后的账单相关接口 */
import request from '@/utils/util.request';

/*
 *  (bill) 账单页面，加载数据
 */
export const bill_load_data = (data) => {
	return request({
		url: '/bill/loaddata',
		data,
	});
};
